import React from 'react';
import SupportPlaceholderPage from './SupportPlaceholderPage';

export default function SupportAnalytics() {
  return (
    <SupportPlaceholderPage
      title="Support Analytics"
      description="Track volumes, response times, and satisfaction across channels"
    />
  );
}
